export default "/presentation/resources/sap/ui/webcomponents/main/messagebundle_cs.81d0171bc73a68d8.json"